import { FC, ReactElement } from 'react';
import Box from '@mui/material/Box';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { ItemButtonIcon } from './styled';

interface Props {
  onClick?: () => void;
  icon?: ReactElement<SvgIconTypeMap>;
  children?: ReactElement;
}

export const ItemButtonSimple: FC<Props> = ({ children, onClick, icon }) => {
  return (
    <Box>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }} onClick={onClick}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ItemButtonIcon sx={{ mr: 2 }}>{icon}</ItemButtonIcon>
            {children}
          </Box>
          <Box>
            <ChevronRightOutlinedIcon sx={{ color: 'neutrals.beige4' }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ItemButtonSimple;
